module.exports = __webpack_public_path__ + "img/image24@2x.123223f5.png";